// ../build/src/injections/dev.js
var __DEV__ = process.env.NODE_ENV !== "production";

// src/get-type.ts
function getType(input) {
  return Object.prototype.toString.call(input).slice(8, -1).toLowerCase();
}

// src/clone.ts
function cloneIdentity(input) {
  return input;
}
function cloneBasic(input) {
  return new input.constructor(input);
}
function cloneSymbol(input) {
  return Object(Symbol.prototype.valueOf.call(input));
}
function cloneObject(input) {
  const output = {};
  for (const key in input) {
    output[key] = clone(input[key]);
  }
  return output;
}
function cloneArray(input) {
  return input.map(clone);
}
function cloneSet(input) {
  const output = new Set();
  input.forEach((value) => {
    output.add(clone(value));
  });
  return output;
}
function cloneMap(input) {
  const output = new Map();
  input.forEach((value, key) => {
    output.set(key, clone(value));
  });
  return output;
}
var CLONE_MAP = {
  default: () => null,
  null: () => null,
  undefined: () => null,
  boolean: cloneBasic,
  number: cloneBasic,
  string: cloneBasic,
  error: cloneBasic,
  date: cloneBasic,
  regexp: cloneBasic,
  function: cloneIdentity,
  symbol: cloneSymbol,
  array: cloneArray,
  object: cloneObject,
  map: cloneMap,
  set: cloneSet
};
function clone(value) {
  if (typeof value !== "object" || value === null) {
    return value;
  }
  const type = getType(value);
  const cloner = CLONE_MAP[type] || CLONE_MAP.default;
  return cloner(value);
}

// src/overwrite.ts
function overwrite_default(source, value) {
  if (typeof source !== "object" || typeof value !== "object") {
    return source;
  }
  let prop;
  for (prop in source) {
    if (prop in value) {
      source[prop] = value[prop];
      continue;
    }
    delete source[prop];
  }
  return source;
}
export {
  clone,
  overwrite_default as overwrite
};
//# sourceMappingURL=harlem-utilities.bundler.esm.js.map
